import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Loader2, ArrowLeft } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [ok, setOk] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, password });
      setOk(true);
      setTimeout(() => nav("/login"), 1500);
    } catch (ex) {
      const d = ex.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Link non valido o scaduto");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#090D14] flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <img src="/betti-logo.jpg" alt="Betti SRL" className="w-12 h-12 rounded-xl object-cover bg-white shadow-lg" />
          <h1 className="font-head font-bold text-xl text-slate-100">Betti SRL</h1>
        </div>
        <div className="bg-[#121824] border border-[#222D42] rounded-2xl p-6 shadow-2xl space-y-4">
          <h2 className="font-head text-lg font-semibold text-slate-100">Nuova password</h2>
          {ok ? (
            <p data-testid="reset-success" className="text-sm text-emerald-400">Password aggiornata! Ti sto reindirizzando all'accesso…</p>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              {err && <div data-testid="reset-error" className="bg-red-500/10 border border-red-500/20 text-red-400 text-sm rounded-lg px-3 py-2">{err}</div>}
              <div>
                <label className="text-xs uppercase tracking-wider text-slate-500 font-medium block mb-1.5">Nuova password</label>
                <input data-testid="reset-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-[#1A2335] border border-[#222D42] rounded-lg px-3 py-2.5 text-sm text-slate-100 focus:outline-none focus:border-amber-500/50" placeholder="••••••••" />
              </div>
              <button data-testid="reset-submit-button" type="submit" disabled={loading || !token} className="w-full bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold py-2.5 rounded-lg transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Aggiorna password
              </button>
            </form>
          )}
          <Link to="/login" className="inline-flex items-center gap-1 text-xs text-slate-500 hover:text-amber-400 transition-colors"><ArrowLeft className="w-3.5 h-3.5" /> Torna all'accesso</Link>
        </div>
      </div>
    </div>
  );
}
